import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {flatMap} from 'lodash';
import {Evaluation360Record} from 'src/app/360-evaluation/_interfaces/360-evaluation-record.interface';
import {BaseClass} from 'src/app/shared/classes/base';
import {
    ProcessConfig,
    QuestionConfig,
    QuestionGroupCategory,
} from 'src/app/shared/interfaces/process-config.interface';
import {TranslationService} from 'src/app/shared/services/translation.service';
import {ConfigService} from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-360-evaluation-report',
    templateUrl: './360-evaluation-report.component.html',
    styleUrls: ['./360-evaluation-report.component.scss'],
})
export class Evaluation360ReportComponent extends BaseClass implements OnChanges {

    @Input() titleKey: string;
    @Input() readonly showMoreLess: Boolean;

    public scrollEnabled: boolean;

    public allManagerQuestions: Array<QuestionConfig>;
    public allGenericQuestions: Array<QuestionConfig>;
    public allPeerQuestions: Array<QuestionConfig>;
    public genericQuestions: any;
    public managerQuestions: any;
    public peerQuestions: any;
    public peers: Array<Evaluation360Record>;
    public subordinates: Array<Evaluation360Record>;
    public currentLanguage: string;
    public columnSize = 2;
    public peerHeaderWidth: { width: string } = null;
    public subordinateHeaderWidth: { width: string } = null;

    show =
        {
            showQuestions: Array<boolean>(),
            showTitles: Array<boolean>(),
            showName: false,
            showP1Name: false,
            showP1Questions: Array<boolean>(),
            showP2Name: false,
            showP2Questions: Array<boolean>(),
        };


    @Input()
    set processConfig(processConfig: ProcessConfig) {
        if (!processConfig) return;
        let currentIndex = 1;
        processConfig.questionsGroups.sort((a, b) => a.order - b.order);
        processConfig.questionsGroups.forEach((g) => {
            g.questions.sort((a, b) => a.order - b.order);
            g.questions.forEach((q) => {
                q.currentIndex = currentIndex;
                currentIndex++;
            });
        });

        this.genericQuestions = processConfig.questions;
        this.managerQuestions = processConfig.questionsGroups.filter(
            (x) => x.category === QuestionGroupCategory.Manager
        );
        this.peerQuestions = processConfig.questionsGroups.filter(
            (x) => x.category !== QuestionGroupCategory.Manager
        );
        if (!this.managerQuestions) this.managerQuestions = this.peerQuestions;

        this.allGenericQuestions = flatMap(this.genericQuestions, (qg) => qg.questions)
            .filter(q => q !== null);
        this.allManagerQuestions = flatMap(this.managerQuestions, (qg) => qg.questions)
            .filter(q => q !== null);
        this.allPeerQuestions = flatMap(this.peerQuestions, (qg) => qg.questions)
            .filter(q => q !== null);
    }

    @Input()
    set evaluations(evaluations: Array<Evaluation360Record>) {
        if (!evaluations) return;
        this.peers = evaluations.filter((x) => !x.isSubordinate);
        this.subordinates = evaluations.filter((x) => x.isSubordinate);
        this.peerHeaderWidth = this.getPeerCardHeaderStyles();
        this.subordinateHeaderWidth = this.getSubordinateCardHeaderStyles();
    }

    @Input() readonly external: boolean = false;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        this.currentLanguage = _translationService.getSelectedLanguage();
        this.scrollEnabled = this._configService.settings.features.scrollSeeEvalOnManagerEvalEnabled;
    }

    ngOnChanges(changes: SimpleChanges) {
        if(!changes.titleKey){
            this.titleKey = !this.external ? this.titleKey : 'performanceCycle.externalThreeSixtyEvaluation';
        }
        else {
            this.titleKey = this.titleKey.indexOf('-') > -1 ? this.titleKey.split('-')[1] : this.titleKey;
        }
    }

    public getGlobalizedValue(value, question) {
        if (
            question &&
            question.typeConfig &&
            question.typeConfig.possibleValuesGlobalized &&
            question.typeConfig.possibleValues
        ) {
            const idx = question.typeConfig.possibleValues.findIndex(
                (x) => x === value
            );
            if (idx === -1) return value;

            return question.typeConfig.possibleValuesGlobalized[this.currentLanguage][
                idx
                ];
        } else return value;
    }

    public getPeerCardHeaderStyles() {
        if (this.scrollEnabled && this.peers && this.peers.length > 0) {
            if (this.genericQuestions && this.genericQuestions.length > 0) {
                if ((this.allGenericQuestions.length * 200) + 245 > 960)
                    return {width: (this.allGenericQuestions.length * 200) + 245 + 'px'};
                return null;
            } else if (this.peerQuestions && this.peerQuestions.length > 0) {
                if ((this.allPeerQuestions.length * 200) + 245 > 960)
                    return {width: (this.allPeerQuestions.length * 200) + 245 + 'px'};
                return null;
            }
        } else {
            return null;
        }
    }

    public getSubordinateCardHeaderStyles() {
        if (this.scrollEnabled && this.subordinates && this.subordinates.length > 0) {
            if (this.managerQuestions && this.managerQuestions.length > 0) {
                if ((this.allManagerQuestions.length * 200) + 245 > 960)
                    return {width: (this.allManagerQuestions.length * 200) + 245 + 'px'};
                return null;
            } else if (this.genericQuestions && this.genericQuestions.length > 0) {
                if ((this.allGenericQuestions.length * 200) + 245 > 960)
                    return {width: (this.allGenericQuestions.length * 200) + 245 + 'px'};
                return null;
            }
        } else {
            return null;
        }
    }
}
